import { Maybe } from '../gql/generated/graphql';

export const formatTwilioPhone = (phoneNum: Maybe<string>) => {
  if (!phoneNum) {
    return '';
  }

  const cleaned = phoneNum.replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `+1${match[2]}${match[3]}${match[4]}`;
  }
  return '';
};

// Strips a US phone number to 10 digits, returning null if the input doesn't normalize
// to exactly 10 digits. Used at mutation boundaries that require the bare digit form.
export const cleanPhoneNumber = (phoneNumber: string): string | null => {
  const cleaned = phoneNumber.replace(/^\+1/, '').replace(/\D/g, '');
  if (!cleaned || cleaned.length !== 10) {
    return null;
  }
  return cleaned;
};
